import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  FormControl,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
} from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import Heading from "../../../StyledComponents/Heading/Heading";
import { makeStyles } from "@material-ui/styles";
import { Download } from "@material-ui/icons";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import ProceedBtn from "../NewInvoice/InvoiceGuidLines/proceedbtn";
import { ArrowBack, Delete, Error } from "@material-ui/icons";
import downloadAttachments from "../../../Functions/downloadAttachments";
import VendorCode from "../NewInvoice/Dropdowns/VenderCode";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import Vendor_Table from "../NewInvoice/Tables/Vendor_Table";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";
import ExpenseTable from "../NewInvoice/Tables/ExpenseTable";
import SearchUsersRole from "../NewInvoice/Dropdowns/SearchUserRole";
import GL_Table_HR_ProcessInvoiceV2 from "../NewInvoice/Tables/GL_Table_HR_ProcessInvoice_V2.js";
import GL_Table_APS from "../NewInvoice/Tables/GL_Table_DetailAPS.js";
import {
  createInvoiceByIR,
  createNewInvoice,
  getCommentsByInvoiceId,
  getCommentsByERFInvoiceNo, 
  getCommentsByARFInvoiceNo, 
  getInvoiceByInvoiceIdAndRoleId,
  getVendorDetail,
  getVendorByPO,
  getPODetails,
  uploadAdditioalDocumentFile,
  uploadFile,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  submit_APSInvoice,
  getRefrenceDataList,
  uploadFile_v1,
  getMethodForPageRefresh,
  changeInvoiceStatus,
} from "../actions";
import { getAllInvoiceDetailByInvoiceIdV2 } from "../ProcessInvoice/actions.js";
import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
// import PaymentDetail from "../Components/PaymentDetails/PaymentDetail";
import PaymentDetail from "../Components/PaymentDetails/PaymentDetail.js";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import { useNavigate } from "react-router-dom";
import { getUserRoles } from "../../Home/actions";
import getParameterByName from "../../../Functions/functions";
import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import GL_Table_ProcessInvoice from "../NewInvoice/Tables/GL_Table_ProcessInvoice";
import FileAttachments from "../../../components/Attachments/FileAttachments";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import WarningBox from "../Components/WarningBox";
import jwt from "jsonwebtoken";
import TaxTable from "../NewInvoice/Tables/Tax_Table";
import TaxTableV2 from "../NewInvoice/Tables/TaxTableV2.jsx";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import PaymentImport from "../NewInvoice/Payment/PaymentImport";
import ExpenseDetail from "../NewInvoice/Tables/ExpenseDetail.js";
import FER_Fuel_General_Allowance from "../NewInvoice/Tables/FERTables/FER_Fuel_General_Allowance.js";
import FER_General from "../NewInvoice/Tables/FERTables/FER_General.js";
import FER_Allowance from "../NewInvoice/Tables/FERTables/FER_Allowance.js";
import { addZeroes } from "../../../Functions";
import PageNotFound from "../NewInvoice/PageNotFound.js";
import InvoiceCompleted from "../Components/InvoiceCompleted";

const useStyles = makeStyles(dashboardStyle);

const APS_Invoice = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");
  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  const [warningFlag, setWarningFlag] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [multipleData, setMultipleData] = useState({
    glAccount: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    invoice_Type: [],
    erf_ExpenseInvoice_Detail: [],
    fer_Invoice_Detial: [],
  });
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [docError, setDocError] = useState("");
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [Post, setPost] = useState(true);
  const handleDateClick = () => {
    // Set open state to true when clicking on posting date value
    setDatePickerOpen(true);
  };

  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    if (invoicePayload?.Invoice_id) {
      getMethodForPageRefresh(
        invoicePayload?.Invoice_id,
        status,
        setAllowToProceed,
        setPageLoader
      );
    }
  }, [invoicePayload?.Invoice_id, status]);
  const [formState, setFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    calculateTax: true,
    // LogisticInvoices: false,
    // VendorPrePayment: false,
    // VendorFinancingPayment: false,
    invoice_Id: 0,
    daysto_sale_taxlapse: 0,
    grn_No: "",
    pO_No: "",
    po_Date :"",
    plant_Code : "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    firstClearText: "",
    secondClearText: "",
    due_Date: moment().format("YYYY-MM-DD"),

    additionalDocIds_array: [], // additional documents in array
    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: true,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: moment().format("YYYY-MM-DD"),
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
    },
    // Tax Table data
    taxCard_List: [],
    vendor_tax_detail: [], // tax exemption
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      {
        poItem: "", //  item #
        poNumber: "", // poNumber
        refDoc: "", // GRN No
        quantity: "", // GRN quantity
        val_Loccur: "", // GRN amount
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: 0, // consumed Amount
        inpuT_QTY: "", //  invoice QTY
        inpuT_VAL: "", //  Invoice amount
        currency: "", // currency
      },
    ],
    salesTaxAmount: "",
    salesTaxCode: "",
    verified: false,
  });

  const [newFormState, setNewFormState] = useState({
    invoiceId: parseInt(invoicePayload.Invoice_id),
    comments: "",
    additional_Docs: [],
    action: "Completed",
    add_Reviser: "",
    reason: "",
    posting_Date: moment().format("YYYY-MM-DD"),
    payment_Method: "",
    house_Bank: "",
    refrence_DocNo: "",
    invoice_Desc: "",
    calculateTax: true,
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [openProceedBtn, setOpenProceedBtn] = useState(false);
  const [invoiceCompleted, setInvoiceCompleted] = useState(false);
  const [attachmentURL, setAttachmentURL] = useState();
  const [attachmentURLList, setAttachmentURLList] = useState([]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
  const confirmedForInvoiceCreation = () => {
    setErrorMessage("");
    submit_APSInvoice(
      newFormState,
      setErrorMessage,
      setSuccessMessage,
      setAttachInvoiceLoading,
      setOpenProceedBtn,
      setInvoiceCompleted,
      navigate,
      setPost
    );
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (
      user?.UserName === "kumar das" ||
      user?.LoginId === "44584900-7d91-460e-91f2-8b9b82bbe35f"
    ) {
      confirmedForInvoiceCreation(); //this is for Invoice proceed pop up msg: do not show this msg to KD
    } else {
      setOpenProceedBtn(true);
    }
  };
  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   submit_APSInvoice(
  //     newFormState,
  //     setErrorMessage,
  //     setSuccessMessage,
  //     setAttachInvoiceLoading,
  //     navigate
  //   );
  // };
  // >>>___FileAttachment____

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  useEffect(() => {
    if (invoicePayload && role) {
      getVendorDetail(invoicePayload?.Vendor_Code, setVendorList, () => {});
      getInvoiceByInvoiceIdAndRoleId(
        invoicePayload,
        role,
        setFormState,
        () => {},
        setNewFormState
      );

      getAllInvoiceDetailByInvoiceIdV2(
        setFormState,
        setMultipleData,
        invoicePayload?.Invoice_id,
        () => {},
        () => {},
        "APS",
        () => {}
      );
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);

      setNewFormState((newFormState) => ({
        ...newFormState,
        invoice_id: invoicePayload?.Invoice_id,
      }));
    }
    getUserRoles(setRoles, setRolesLoading);
  }, []);

  useEffect(() => {
    if (invoicePayload && role) {
      if (formState?.invoice_Type === "ERF") {
        getCommentsByERFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      }
      
      else if (formState?.invoice_Type === "ARF") {
        getCommentsByARFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      }
      else {
        getCommentsByInvoiceId(
          setCommentsList,
          setCommentsLoading,
          invoicePayload?.Invoice_id
        );
      }
    }
  }, [formState.invoice_Type]);
  // useEffect(() => {
  //   if (formState?.additionalDocIds?.length > 0) {
  //     const filterd = formState?.additionalDocIds?.filter((x) => x !== "");

  //     setAttachmentURLList((pre) => [
  //       ...pre,
  //       formState?.invoice_attachment,
  //       ...filterd,
  //     ]);
  //     if (formState?.invoice_attachment) {
  //       setAttachmentURL(formState?.invoice_attachment);
  //     } else {
  //       setAttachmentURL(formState?.additionalDocIds[0]);
  //     }
  //     // setAttachmentURL(formState?.invoice_attachment);
  //   }
  // }, [formState?.additionalDocIds]);

  const [firstTime, setFirstTime] = useState(true);
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    if (
      // selectedRole.roleName === "APS" &&
      formState?.additionalDocIds?.length > 0
    ) {
      let filterd_data = [];
      filterd_data = formState?.additionalDocIds.filter((x) => x?.path !== "");
      var semiFinal = filterd_data.filter(function (item) {
        return !attachmentURLList.includes(item?.path);
      });

      let i = [formState?.invoice_attachment?.path];
      var final = semiFinal.filter(function (item) {
        return !i.includes(item?.path);
      });
      if (firstTime) {
        setFirstTime(false);
        setAttachmentURLList([...final, formState?.invoice_attachment]);
        setAttachmentURL(formState?.invoice_attachment);
      } else {
        if (final.length > 0) {
          setAttachmentURLList([...final, formState?.invoice_attachment]);
          setAttachmentURL(final[0]);
        }
      }
    } else if (formState?.invoice_attachment?.path) {
      setAttachmentURLList([formState?.invoice_attachment]);
      setAttachmentURL(formState?.invoice_attachment);
    }
  }, [formState?.additionalDocIds, formState?.invoice_attachment]);

  useEffect(() => {
    if (newFormState.additional_Docs?.length > 1) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState.additional_Docs[newFormState.additional_Docs.length - 1],
      ]);
    } else {
      setAttachmentURLList((pre) => [...pre, ...newFormState.additional_Docs]);
    }
  }, [newFormState?.additional_Docs]);
  useEffect(() => {
    if (formState?.invoice_Id !== 0) {
      setPoBasedState(formState?.pO_Based ? "PO" : "Non-PO");
    }
  }, [formState]);
  useEffect(() => {
    // Generate menu items based on the conditions
    if (
      formState?.isImport &&
      formState.demandType !== "Deposit" &&
      !formState?.isPSID
    ) {
      setMenuItems([
        { text: "Rework", value: "SendToIP" },
 { text: "Reverse", value: "Reverse" },
        { text: "Reverse 1st Clearing", value: "ReverseFirstClearing" },
        { text: "Reverse 1st & MIRO Clearing", value: "ReverseAllClearing" },
        //{text:"Reverse", value:"SendToIR"}, this one commented in 1.0
        { text: "Change", value: "Change" },
        { text: "Ok For Payment", value: "Completed" },
        { text: "Approve but not for payment", value: "ApproveOnly" },
      ]);
    } else if (
      formState?.isImport &&
      formState.demandType !== "Deposit" &&
      formState?.isPSID
    ) {
      setMenuItems([
        { text: "Rework", value: "Rework" },
        //{text:"Reverse 2nd Clearing", value:"ReverseSecondClearing"}, this one commented in 1.0
        { text: "Reverse 1st & 2nd Clearing", value: "ReverseBothClearing" },
        {
          text: "Reverse 1st, 2nd & MIRO Clearing",
          value: "ReverseAllClearing",
        },
        //{text:"Reverse", value:"SendToIR"},
         { text: "Reverse", value: "Reverse" },
        { text: "Change", value: "Change" },
        { text: "Ok For Payment", value: "Completed" },
        { text: "Approve but not for payment", value: "ApproveOnly" },
      ]);
    } else {
      // Handle other conditions if needed
      setMenuItems([
        {
          text: "Add reviewer/ approver",
          value: "Add reviewer/ approver",
        },
        { text: "Rework", value: "Rework" },
        { text: "Reverse", value: "Reverse" },
        { text: "Change", value: "Change" },
        { text: "Ok For Payment", value: "Completed" },
        { text: "Approve but not for payment", value: "ApproveOnly" },
      ]);
    }
  }, [formState]);
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
  }, []);

  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const clearState = () => {
    setNewFormState((newFormState) => ({
      ...newFormState,
      // additional_Docs: [],
      add_Reviser: "",
      reason: "",
      posting_Date: null,
      payment_Method: "",
      house_Bank: "",
      refrence_DocNo: "",
      invoice_Desc: "",
    }));
  };
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [openWarningBox, setOpenWarningBox] = useState(false);

  const deleteInvoice = () => {
    const data = {
      Id: newFormState?.invoice_attachment?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(function (item) {
          return ![newFormState?.invoice_attachment?.path].includes(item);
        });

        const filteredAttachmentsSR = newFormState?.attachment_Sr.filter(
          (x) => x !== newFormState?.invoice_attachment?.id
        );
        setAttachmentURLList(final);
        setNewFormState((formState) => ({
          ...formState,
          invoice_attachment: "",
          attachment_Sr: filteredAttachmentsSR,
        }));
        invoice_attachmentRef.current.value = null;
        setOpenWarningBox(false);
        setdeleteLoader(false);
        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        // setErrorMessage(error.response.data);
      });
  };

  const invoiceCompletedHandler = () => {
    changeInvoiceStatus(
      formState.invoice_Id,
      'Completed',
      setInvoiceCompleted,
      setAttachInvoiceLoading,
      setSuccessMessage,
      setErrorMessage,
      navigate,
      formState.comments,
      formState.aditional_Comments,
      setPost
    );
  }
  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState.additional_Docs.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additional_Docs: files,
        }));

        setdeleteLoader(false);
        setOpenWarningBox(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (
      newFormState?.invoice_attachment === "" &&
      e.dataTransfer.files &&
      e.dataTransfer.files[0] 
     
    ) {
      uploadFile_v1(
        e,
        setNewFormState,
        setAttachInvoiceLoading,
        "invoice_attachment",
        setAttchmentFile_UI,
        invoice_attachmentRef,
        setAttachmentURLList,
        setAttachmentURL,
        attachmentURLList,
        newFormState?.invoice_attachment,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    } else {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttchmentLoader,
        "additional_Docs",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };

  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };

  const calculateTotalGLAmount = () => {
    const totalGLAmount = formState?.invoice_Accounts?.reduce(
      (accumulator, currentValue) => {
        const amountWithoutCommas = String(currentValue?.amount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));
  
        if (currentValue?.accountType === 'Debit') {
          return accumulator + numericAmount; 
        } else if (currentValue?.accountType === 'Credit') {
          return accumulator - numericAmount;  
        }
        return accumulator; 
      },
      0
    );
  
    return Math.abs(totalGLAmount);
  };
  const totalAmount = calculateTotalGLAmount();
  return (
    <>
      {/* {allowToProceed ? ( */}
        <Card
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={dragloader || pageLoader}
          ></Backdrop>
          <CardHeader color="primary" text>
            <CardText
              style={{
                padding: "0px 27px",
                backgroundColor: "#031C30",
                color: "white",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={2} sm={3} md={3} lg={6}>
                  <h1 style={{ fontSize: "24px" }}>APS Review</h1>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <IconButton
                    variant="contained"
                    style={{ float: "right", marginTop: "1.5%" }}
                    onClick={() => navigate("/home")}
                  >
                    <ArrowBack
                      style={{ color: "#fff" }}
                      titleAccess="Go Back"
                    />
                  </IconButton>
                </Grid>
              </Grid>
            </CardText>
          </CardHeader>
          <CardBody>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={attachInvoiceLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2} style={{ marginTop: "1px" }}>
              {/* Submitter role */}
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span>Submitter Role:
                </Typography>
                <Autocomplete
                  id="submitter_role"
                  options={roles}
                  size="small"
                  value={selectedRole}
                  getOptionLabel={(option) =>
                    (option !== "" && `${option?.roleName}`) || ""
                  }
                  loading={rolesLoading}
                  onChange={(event, newValue) => {
                    roleHandler(newValue);
                  }}
                  disabled
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
            </Grid>
            {!formState.isImport && !formState?.isPCDV && !formState?.isHR && (
              <InvoiceCheckboxes
                formState={formState}
                setFormState={setFormState}
                selectedRole="IP"
                disabled={true}
              />
            )}
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={6}>
                {!formState.isImport &&
                  !formState?.isPCDV &&
                  !formState?.isHR && (
                    <InvoiceRadioButtons
                      formState={formState}
                      setFormState={setFormState}
                      selectedRole="IP"
                      physicalOrEInvoice={physicalOrEInvoice}
                      poBasedState={poBasedState}
                      alignForAttachment={true}
                    />
                  )}
                <InvoiceTextField
                formState={{
                  ...formState,
                  po_Date : formState?.po_Date , 
                  plant_Code : formState?. plant_Code 
                }}
                  newFormState={formState}
                  setNewFormState={setFormState}
                  selectedRole="IP"
                  disabled={true}
                  poBasedState={poBasedState}
                  showVendorAndPO_NumberForImport={
                    showVendorAndPO_NumberForImport
                  }
                  showVendorCodeForImport={showVendorCodeForImport}
                  invoice_attachmentRef={invoice_attachmentRef}
                  additionalAttachmentRef={additionalAttachmentRef}
                  setAttachInvoiceLoading={setAttachInvoiceLoading}
                  //   setAttchmentFile_UI={setAttchmentFile_UI}
                  //   attachmentFile_UI={attachmentFile_UI}
                  physicalOrEInvoice={physicalOrEInvoice}
                  changeHandler={changeHandler}
                  alignForAttachment={true}
                  setAttachmentURLList={setAttachmentURLList}
                  attachmentURLList={attachmentURLList}
                  setAttachmentURL={setAttachmentURL}
                  showAttachmentsHandler={showAttachmentsHandler}
                  multipleData={multipleData}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                style={{ paddingLeft: "7px" }}
              >
                <Heading title="Attachment Preview" />

                <AttachmentsCover
                  attachmentURLList={attachmentURLList}
                  setAttachmentURLList={setAttachmentURLList}
                  attachmentURL={attachmentURL}
                  setAttachmentURL={setAttachmentURL}
                  formState={formState}
                  invoice_attachmentRef={invoice_attachmentRef}
                />
              </Grid>
            </Grid>
            {/* payment detail */}
            {!formState?.isLogistics && (
              <PaymentDetail
                formState={formState}
                setFormState={setFormState}
                multipleData={multipleData}
                disabled={true}
                // disabled={user.Location === "1" ? false : true}//this is set for MPAS user because payment detail enable for MPAS user only
              />
            )}
            {/* Tax  */}
            {formState.invoice_Type !== "DES" &&
              formState.invoice_Type !== "ERF" &&
              formState.invoice_Type !== "FER" &&
              !formState?.isHR && !formState.isPCDV && (
                <>
                  <Heading title="Tax" />

                  <TaxDetail
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    formState={formState}
                    setFormState={setFormState}
                    invoice_Amount={newFormState.invoice_Amount}
                    disabled={true}
                    roleName={roleName}
                  />
                  {formState?.invoice_No && !formState?.isHR && (
                    <TaxTableV2
                      formState={formState}
                      setFormState={setFormState}
                      invoice_Amount={formState.invoice_Amount}
                      invoicePayload={invoicePayload}
                      show={true} // to disable the add new button
                      edit={false}
                      isProceed={false} //required
                      setTaxErrorMsg={() => {}}
                      taxErrorMsg={() => {}}
                    />
                    //   <TaxTable
                    //   formState={formState}
                    //   setFormState={setFormState}
                    //   invoice_Amount={formState.invoice_Amount}
                    //   invoicePayload={invoicePayload}
                    //   show={true} // to disable the add new button
                    //   edit={false}
                    //   isProceed={false} //required
                    //   setTaxErrorMsg={() => {}}
                    //   taxErrorMsg={() => {}}
                    // />
                  )}
                  {formState.invoice_No && !formState?.isHR && (
                    <VendorTaxTable
                      formState={formState}
                      setFormState={setFormState}
                    />
                  )}
                </>
              )}

            {/* <TaxTable_Short
          formState={formState}
          setFormState={setFormState}
          invoicePayload={invoicePayload}
          disabled={true}
        /> */}
            <span></span>

            {/* G/L Account */}
            {formState.invoice_Type === "ERF" && (
              <ExpenseDetail multipleData={multipleData} />
            )}
            {formState.invoice_Type === "FER" && (
              <>
                <FER_Fuel_General_Allowance multipleData={multipleData} />
                {/* <FER_General multipleData={multipleData}/>
          <FER_Allowance multipleData={multipleData}/> */}
              </>
            )}
            {formState?.isHR &&
            formState.invoice_Type !== "ERF" &&
            formState.invoice_Type !== "FER" ? (
              <div style={{ marginTop: "20px" }}>
                <Heading title="G/L Account" />
                <GL_Table_HR_ProcessInvoiceV2
                  formState={formState}
                  setFormState={setFormState}
                  setGLAccountTotal={() => {}}
                  importPaymentDetail={() => {}}
                  disabled={true}
                  setImportPaymentDetail={() => {}}
                  setErrorMessageForAmount={() => {}}
                />
              </div>
            ) : (
              formState.invoice_Type !== "ERF" &&
              formState.invoice_Type !== "FER" &&
              formState.invoice_No && (
                <div style={{ marginTop: "20px" }}>
                  <Heading title=" G/L Account" />
                  <GL_Table_APS
                    formState={formState}
                    setFormState={setFormState}
                    setGLAccountTotal={() => {}}
                    importPaymentDetail={() => {}}
                    disabled={true}
                    setImportPaymentDetail={() => {}}
                    setErrorMessageForAmount={() => {}}
                  />
                </div>
              )
            )}

            {formState?.pO_Based &&
              formState?.invoice_Type !== "ERF" &&
              formState.invoice_Type !== "FER" && (
                <>
                  <PODetail
                    formState={formState}
                    setFormState={setFormState}
                    disabled={true}
                  />
                  {/* GRN Total */}
                  <Grid container spacing={2}>
                    <Grid item sm={6} md={3} lg={1}>
                      <b>GRN Total:</b>
                    </Grid>
                    <Grid item sm={6} md={3} lg={2}>
                     {/* <b>
                        {addZeroes(
                          formState?.invoicePORef_List
                            ?.map((data) => data.inpuT_VAL)
                            .reduce(
                              (prev, curr) => Number(prev) + Number(curr),
                              0
                            )
                        )}
                      </b> */}
                    <b>
                      {addZeroes(
                        formState?.invoicePORef_List
                          ?.map((data) => data.val_Loccur)
                          .reduce(
                            (prev, curr) => Number(prev) + Number(curr),
                            0
                          )
                      )}
                    </b>
                  </Grid>
                </Grid>
                {/* GRN Invoice */}
                <Grid container spacing={2}>
                  <Grid item sm={6} md={3} lg={1}>
                    <b>GRN Invoice:</b>
                  </Grid>
                  <Grid item sm={6} md={3} lg={2}> 
                      <b>
                        {addZeroes(
                          formState?.invoicePORef_List
                            ?.map((data) => data.inpuT_VAL)
                            .reduce(
                              (prev, curr) => Number(prev) + Number(curr),
                              0
                            )
                        )}
                      </b>
                    </Grid>
                  </Grid>
                  {/* input tax amount */}
                  <Grid container>
                    <Grid item sm={6} md={3} lg={1}>
                      <b>Input Tax Amount:</b>
                    </Grid>
                    <Grid item sm={6} md={3} lg={2}>
                      <b>{addZeroes(formState?.salesTaxAmount)} </b>
                    </Grid>
                  </Grid>
                  {/* GL entry */}
                  <Grid container spacing={2}>
                    <Grid item sm={6} md={3} lg={1}>
                      <b>GL Entry:</b>
                    </Grid>
                    <Grid item sm={6} md={3} lg={2}>
                      <b>{addZeroes(totalAmount?.toLocaleString())}</b>
                    </Grid>
                    </Grid>
                 {/* GRN Invoice Total */}
                <Grid container>
                  <Grid item sm={6} md={3} lg={1}>
                    <b>GRN Invoice Total:</b>
                  </Grid>
                  <Grid item sm={6} md={3} lg={2}>
                    <b>
                      {addZeroes(
                        Number(
                          formState?.invoicePORef_List
                            ?.map((data) => data.inpuT_VAL)
                            .reduce(
                              (prev, curr) => Number(prev) + Number(curr),
                              0
                            )
                        ) +
                          Number(formState?.salesTaxAmount) +
                          Number(totalAmount)
                      )}
                    </b>
                  </Grid>
                  </Grid>
                  {/* Total Cost */}
                  <Grid container>
                    <Grid item sm={6} md={3} lg={1}>
                      <b>Total Cost:</b>
                    </Grid>
                    <Grid item sm={6} md={3} lg={2}>
                      <b>
                        {addZeroes(
                          Number(
                            formState?.invoicePORef_List
                              ?.map((data) => data.inpuT_VAL)
                              .reduce(
                                (prev, curr) => Number(prev) + Number(curr),
                                0
                              )
                          ) +
                            totalAmount
                        )}
                      </b>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={6} md={3} lg={1}>
                      <b>Invoice Amount:</b>
                    </Grid>
                    <Grid item sm={6} md={3} lg={2}>
                      <b>
                        {addZeroes(
                          Number(
                            formState?.invoicePORef_List
                              ?.map((data) => data.inpuT_VAL)
                              .reduce(
                                (prev, curr) => Number(prev) + Number(curr),
                                0
                              )
                          ) +
                            Number(formState?.salesTaxAmount) +
                            totalAmount
                        )}
                      </b>
                    </Grid>
                  </Grid>
                </>
              )}
            {!formState.pO_Based &&
              formState.invoice_Type !== "ERF" &&
              formState.invoice_Type !== "FER" && (
                <PaymentImport
                  formState={formState}
                  vendor={{
                    name: formState?.vendor_Name || "",
                    code: formState?.vendor_Code || "",
                  }}
                  inv_amount={formState?.invoice_Amount}
                  invoiceData={{
                    taxCode: formState?.salesTaxCode,
                    taxAmount: Number(formState?.salesTaxAmount),
                    GLInvoice_Accounts: formState?.invoice_Accounts,
                    isPCDV: formState?.isPCDV,
                    vendor_Code: formState?.vendor_Code,
                  }}
                  setImportPaymentDetail={() => {}}
                  setFormState={() => {}}
                  formState1={newFormState}
                  multipleData={multipleData}
                  edit={true}
                  disable={true}
                />
              )}
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <CommentHistory
                commentsList={commentsList}
                commentsLoading={commentsLoading}
              />
            </Grid>
            {formState.isImport && formState.demandType !== "Deposit" && (
              <Grid container style={{ margin: "20px 0px" }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="h4">
                    <Heading title="Clearing Detail" />
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} mt={1}>
                  <Typography style={{ color: "black" }}>
                    {!newFormState?.isReturn ? (
                      <span className={classes.asterisk}>*</span>
                    ) : null}
                    First Clearing Text:{" "}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{
                      // width: "70%",
                      "& .MuiInputBase-root": {
                        height: 30,
                      },
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    name="firstClearText"
                    value={formState?.firstClearText}
                    onChange={changeHandler}
                    required={!newFormState?.isReturn}
                    disabled={true}
                  />
                </Grid>
                {formState?.isPSID && (
                  <Grid item xs={12} sm={12} md={3} lg={3} mt={1} ml={1}>
                    <Typography style={{ color: "black" }}>
                      {formState?.isPSID && !newFormState?.isReturn ? (
                        <span className={classes.asterisk}>*</span>
                      ) : null}
                      Second Clearing Text:{" "}
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{
                        // width: "70%",
                        "& .MuiInputBase-root": {
                          height: 30,
                        },
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      id="outlined-basic"
                      variant="outlined"
                      name="secondClearText"
                      value={formState?.secondClearText}
                      onChange={changeHandler}
                      required={formState?.isPSID && !newFormState?.isReturn}
                      disabled={true}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {(formState.isImport &&
              formState.demandType !== "Deposit" &&
              formState?.invoice_No) ||
            (formState?.isHR &&
              formState.invoiceCategory.includes(
                "Final Settlement – Death case"
              ) &&
              formState?.invoice_No) ? (
              <>
                <Vendor_Table
                  formState={formState}
                  setFormState={setFormState}
                  disabled={true}
                  vendorList={vendorList}
                  setVendorList={setVendorList}
                />
              </>
            ) : (
              ""
            )}
            {edit === "true" ? (
              <form onSubmit={submitHandler} style={{ marginTop: "50px" }}>
                <>
                  <Grid container style={{ margin: "5px 0px" }}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                      <FormControl fullWidth size="small">
                        <Typography style={{ color: "black" }}>
                          Action:<span className={classes.asterisk}>*</span>
                        </Typography>

                        <Select
                          size="small"
                          // labelId="demo-simple-select-label"
                          style={{ height: 30 }}
                          value={newFormState?.action}
                          name="action"
                          required
                          placeholder="Select an Action"
                          className={classes.selectEmpty}
                          displayEmpty
                          // disabled={roleName === "AP Manager"}
                          id="demo-simple-select"
                          onChange={(e) => {
                            changeHandler(e);
                            // clearState();
                          }}
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="" disabled>
                            Select an Action
                          </MenuItem>
                          {menuItems?.length > 0 ? (
                            menuItems.map((item) => (
                              <MenuItem key={item.value} value={item.value}>
                                {item.text}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>Not Found</MenuItem>
                          )}

                          {/* {[
                        {
                          action: "Add reviewer/ approver",
                          value: "Add reviewer/ approver",
                        },
                        { action: "Rework", value: "Rework" },
                        { action: "Reverse", value: "Reverse" },
                        { action: "Change", value: "Change" },
                        { action: "Ok For Payment", value: "Completed" },
                      ].map((item) => {
                        return (
                          <MenuItem value={item.value}>{item.text}</MenuItem>
                        );
                      })} */}
                        </Select>
                      </FormControl>
                    </Grid>
                    {newFormState?.action === "Add reviewer/ approver" && (
                      <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                        {/* <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Add Reviewer"
                        apiString="All"
                        placeholder="Select a Reviewer"
                        name="add_Reviser" // pending.
                        formState={newFormState}
                        changeHandler={changeHandler}
                        required={true}
                        classes={classes}
                      />
                    </FormControl> */}
                        <SearchUsersRole
                          label="Add Reviewer"
                          apiString="Reviewer"
                          name="add_Reviser" // pending.
                          placeholder="Select a Reviewer"
                          formState={newFormState}
                          setNewFormState={setNewFormState}
                          changeHandler={changeHandler}
                          required={true}
                          disabled={false}
                          classes={classes}
                        />
                      </Grid>
                    )}
                    {newFormState?.action === "Reverse" && (
                      <>
                        <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                          <FormControl fullWidth size="small">
                            <Typography style={{ color: "black" }}>
                              <span className={classes.asterisk}>*</span>Reason:
                            </Typography>

                            <Select
                              size="small"
                              // labelId="demo-simple-select-label"
                              style={{ height: 30 }}
                              value={newFormState?.reason}
                              name="reason"
                              id="demo-simple-select"
                              required
                              onChange={changeHandler}
                              inputProps={{ "aria-label": "Without label" }}
                              displayEmpty
                              className={classes.selectEmpty}
                            >
                              <MenuItem value="" disabled>
                                Select a Value
                              </MenuItem>
                              {[
                                {
                                  text: "01 - Reversal in current period",
                                  value: "01 - Reversal in current period",
                                },
                                {
                                  text: "02 - Reversal in closed period",
                                  value: "02 - Reversal in closed period",
                                },
                                {
                                  text: "03 - Actual reversal in current period",
                                  value:
                                    "03 - Actual reversal in current period",
                                },
                                {
                                  text: "04 - Actual reversal in closed period",
                                  value:
                                    "04 - Actual reversal in closed period",
                                },
                                {
                                  text :"05 - Approval deferral posting", 
                                  value:"05 - ApprovalDEferral"
                              },
                              ].map((item) => {
                                return (
                                  <MenuItem value={item.value}>
                                    {item.text}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                          <Typography style={{ color: "black" }}>
                            {/* <span className={classes.asterisk}>*</span> */}
                            Posting Date:
                          </Typography>

                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              // value={value}
                              //  disabled={true}
                              open={isDatePickerOpen} // Control the visibility of the calendar
                              onClose={() => setDatePickerOpen(false)}
                              onChange={(newValue) => {
                                setNewFormState((formState) => ({
                                  ...newFormState,
                                  posting_Date: newValue,
                                }));
                              }}
                              value={newFormState?.posting_Date}
                              error={false}
                              // PopperProps={{
                              //   placement: "top-start", // Open the calendar downwards
                              // }}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  size="small"
                                  name="posting_Date"
                                  id="outlined-basic"
                                  variant="outlined"
                                  onChange={changeHandler}
                                  onClick={handleDateClick}
                                  // required
                                  {...params}
                                  error={false}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: 30,
                                    },
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                  }}
                                  // disabled={true}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </>
                    )}
                    {newFormState?.action === "Change" && (
                      <>
                        <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                          <FormControl fullWidth size="small">
                            <Typography style={{ color: "black" }}>
                              {/* <span className={classes.asterisk}>*</span> */}
                              Payment Method:
                            </Typography>

                            <TextField
                              type="text"
                              size="small"
                              name="payment_Method"
                              value={newFormState?.payment_Method}
                              variant="outlined"
                              // required
                              onChange={changeHandler}
                              sx={{
                                // width: "70%",
                                "& .MuiInputBase-root": {
                                  height: 30,
                                },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                          <FormControl fullWidth size="small">
                            <Typography style={{ color: "black" }}>
                              {/* <span className={classes.asterisk}>*</span> */}
                              House Bank:
                            </Typography>

                            <TextField
                              type="text"
                              size="small"
                              name="house_Bank"
                              value={newFormState?.house_Bank}
                              variant="outlined"
                              // required
                              sx={{
                                // width: "70%",
                                "& .MuiInputBase-root": {
                                  height: 30,
                                },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              onChange={changeHandler}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                          <FormControl fullWidth size="small">
                            <Typography style={{ color: "black" }}>
                              {/* <span className={classes.asterisk}>*</span> */}
                              Reference Doc No:
                            </Typography>

                            <TextField
                              type="text"
                              sx={{
                                // width: "70%",
                                "& .MuiInputBase-root": {
                                  height: 30,
                                },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              id="outlined-basic"
                              size="small"
                              name="refrence_DocNo"
                              value={newFormState?.refrence_DocNo}
                              variant="outlined"
                              // required
                              onChange={changeHandler}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                          <FormControl fullWidth size="small">
                            <Typography style={{ color: "black" }}>
                              {/* <span className={classes.asterisk}>*</span> */}
                              Invoice Description:
                            </Typography>

                            <TextField
                              sx={{
                                // width: "70%",
                                "& .MuiInputBase-root": {
                                  height: 30,
                                },
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              }}
                              id="outlined-basic"
                              type="text"
                              size="small"
                              name="invoice_Desc"
                              value={newFormState?.invoice_Desc}
                              variant="outlined"
                              // required
                              onChange={changeHandler}
                            />
                          </FormControl>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <Typography style={{ color: "black" }}>
                        Attach Invoice:
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 30,
                          },
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        // required={newFormState?.invoice_attachment?.path === ""}

                        // onChange={() => }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <input
                                ref={invoice_attachmentRef}
                                type="file"
                                accept=".png, .jpg, .jpeg, .pdf"
                                name="invoice_attachment"
                                onChange={(e) =>
                                  uploadFile_v1(
                                    e,
                                    setNewFormState,
                                    setAttachInvoiceLoading,
                                    "invoice_attachment",
                                    setAttchmentFile_UI,
                                    invoice_attachmentRef,
                                    setAttachmentURLList,
                                    setAttachmentURL,
                                    attachmentURLList,
                                    newFormState?.invoice_attachment,
                                    setDocError,
                                    setAttachError,
                                    setAlertMessage,
                                    invoicePayload,
                                    selectedRole,
                                    // {roleName:selectedRole},
                                    false,
                                    () => {},
                                    setSuccessMessage
                                  )
                                }
                                style={{ width: "209px" }}
                              />
                            </InputAdornment>
                          ),
                        }}
                        FormHelperTextProps={{
                          className: classes.helperText,
                        }}
                        // error={attachError ? true : false}
                        // helperText={attachError ? `${attachError}` : null}
                      />
                      {newFormState?.invoice_attachment && (
                        <>
                          <IconButton
                            size="small"
                            onClick={() => {
                              downloadAttachments(
                                newFormState?.invoice_attachment?.path
                              );
                            }}
                          >
                            <Download color="secondary" />{" "}
                          </IconButton>
                          <IconButton
                        size="small"
                        onClick={() => {
                          setWarningFlag(false);
                          setOpenWarningBox(true);
                        }}
                      >
                        <Delete
                          titleAccess="Delete"
                          color="danger"
                          fontSize="small"
                          // style={{
                          //   color:
                          //     // disable ||
                          //     newFormState?.invoice_attachment?.role_Name !==
                          //     selectedRole
                          //       ? "gray"
                          //       : "",
                          // }}
                        />{" "}
                      </IconButton>

                          <>
                            <IconButton
                              style={{
                                fontSize: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const allowedExtensions = [
                                  ".png",
                                  ".pdf",
                                  ".jpg",
                                  ".jpeg",
                                  ".PNG",
                                  ".JPG",
                                  ".JPEG",
                                  ".PNG",
                                  ".PDF",
                                ];
                                const fileExtension =
                                  "." +
                                  newFormState?.invoice_attachment?.path
                                    ?.split("\\")
                                    [
                                      newFormState?.invoice_attachment?.path?.split(
                                        "\\"
                                      ).length - 1
                                    ].split(".")
                                    .pop();
                                if (allowedExtensions.includes(fileExtension)) {
                                  showAttachmentsHandler(
                                    newFormState?.invoice_attachment
                                  );
                                } else {
                                  showAttachmentsHandler(
                                    newFormState?.invoice_attachment
                                  );
                                  window.open(
                                    `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                                    "_blank"
                                  );
                                }
                              }}
                              s
                            >
                              <span style={{ fontSize: "14px" }}>
                                {
                                  newFormState?.invoice_attachment?.path?.split(
                                    "\\"
                                  )[
                                    newFormState?.invoice_attachment?.path?.split(
                                      "\\"
                                    ).length - 1
                                  ]
                                }
                              </span>
                            </IconButton>
                          </>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
                      <Typography style={{ color: "black" }}>
                        Additional Document:{" "}
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 30,
                          },
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <input
                                ref={additionalAttachmentRef}
                                type="file"
                                name="additional_Docs"
                                onChange={(e) =>
                                  uploadAdditioalDocumentFile(
                                    e,
                                    setNewFormState,
                                    setAttchmentLoader,
                                    "additional_Docs",
                                    additionalAttachmentRef,
                                    setDocError,
                                    setAttachError,
                                    setAlertMessage,
                                    invoicePayload,
                                    selectedRole,
                                    dragfile,
                                    setDragFile,
                                    setSuccessMessage
                                  )
                                }
                                style={{ width: "209px" }}
                                multiple
                              />

                              {attachmentLoader ? (
                                <CircularProgress size={24} />
                              ) : (
                                ""
                              )}
                            </InputAdornment>
                          ),
                        }}
                        // FormHelperTextProps={{
                        //   className: classes.helperText,
                        // }}
                        // error={docError ? true : false}
                        // helperText={docError ? `${docError}` : null}
                      />
                      {newFormState.additional_Docs.length > 0 &&
                        newFormState.additional_Docs.map((f, index) => {
                          const s = f?.path.split("\\");
                          const ss = s[s.length - 1];
                          // above 2 lines is for get name of file
                          return (
                            <>
                              {f?.path !== "" ? (
                                <>
                                  <IconButton>
                                    <Download
                                      onClick={() => {
                                        const files =
                                          newFormState.additional_Docs.find(
                                            (x, i) => {
                                              const n = x?.path?.split("\\");
                                              const nn = n[n.length - 1];
                                              return nn === ss;
                                            }
                                          );
                                        downloadAttachments(files?.path);
                                      }}
                                      color="secondary"
                                    />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      setInvoiceDelete(f);
                                      setOpenWarningBox(true);
                                      setWarningFlag(true);
                                    }}
                                  >
                                    <Delete
                                      color="danger"
                                      fontSize="small"
                                      style={{
                                        color:
                                          f.role_Name !== selectedRole?.roleName
                                            ? "gray"
                                            : "",
                                      }}
                                    />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      const extension = f.path
                                        ?.match(/\.[^.]+$/)[0]
                                        .substring(1);
                                      const allowedExtensions = [
                                        ".png",
                                        ".pdf",
                                        ".jpg",
                                        ".jpeg",
                                        ".PNG",
                                        ".JPG",
                                        ".JPEG",
                                        ".PNG",
                                        ".PDF",
                                      ];
                                      const fileExtension =
                                        "." + ss.split(".").pop();
                                      if (
                                        allowedExtensions.includes(
                                          fileExtension
                                        )
                                      ) {
                                        setAttachmentURL(f);
                                      } else {
                                        if (isContainEmailFormate(extension)) {
                                          downloadAttachments(f.path);
                                        } else {
                                          setAttachmentURL(f);

                                          window.open(
                                            `${process.env.REACT_APP_API_URL}/${f.path}`,
                                            "_blank"
                                          );
                                        }
                                      }
                                    }}
                                  >
                                    <span style={{ fontSize: "12px" }}>
                                      {ss}
                                    </span>
                                  </IconButton>
                                  <div></div>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      style={{ marginTop: "6px" }}
                    >
                      <Typography style={{ color: "black" }}>
                        Comments:
                        {(newFormState?.action == "Rework" ||
                          newFormState?.action == "Reverse" ||
                          newFormState?.action == "Add reviewer/ approver") && (
                          <span className={classes.asterisk}>*</span>
                        )}
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        rows={2}
                        maxRows={4}
                        // size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        required={
                          newFormState?.action == "Rework" ||
                          newFormState?.action == "Reverse" ||
                          newFormState?.action == "Add reviewer/ approver"
                            ? true
                            : false
                        }
                        name="comments"
                        value={newFormState.comments}
                        onChange={changeHandler}
                      />
                    </Grid>
                  </Grid>
                  {(selectedRole?.roleName === "AP Supervisor" ||
                    selectedRole?.roleName === "AP GM" ||
                    selectedRole?.roleName === "AP Manager") && (
                    <Grid container justifyContent="flex-end">
                      {(Post && allowToProceed) && (
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <Button
                            style={{ margin: "2px 0px", float: "right" }}
                            variant="contained"
                            color="secondary"
                            type="submit"
                          >
                            Submit
                          </Button>
                          <Button
                            style={{
                              margin: "2px 10px 0px 0px",
                              float: "right",
                              color: "white",
                            }}
                            variant="contained"
                            color="danger"
                            onClick={() => navigate("/home")}
                          >
                            CANCEL
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  )}
                </>
              </form>
            ) : (
              ""
            )}
          </CardBody>

          {openInvoiceGuideLine && (
            <InvoiceGuideLine
              open={openInvoiceGuideLine}
              close={setOpenInvoiceGuideLine}
            />
          )}
          {openProceedBtn && (
            <ProceedBtn
              open={openProceedBtn}
              close={() => setOpenProceedBtn(false)}
              submit={confirmedForInvoiceCreation}
              attachInvoiceLoading={attachInvoiceLoading}
              formState={newFormState}
            />
          )}
          {successMessage && (
            <CustomSnackbar
              open={successMessage !== ""}
              message={successMessage}
              handleClose={() => setSuccessMessage("")}
              variant="success"
            />
          )}
          {errorMessage && (
            <>
              {" "}
              <Grid container spacing={0}>
                <Grid item>
                  <Error
                    titleAccess="Error"
                    className={classes.asterisk}
                    fontSize="small"
                  />{" "}
                </Grid>
                <Grid item>
                  <Typography className={classes.asterisk} ml={1}>
                    {" "}
                    {errorMessage}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={attachError ? attachError : docError}
              setAttachError={setAttachError}
              setDocError={setDocError}
            />
          )}
          {invoiceCompleted && (
            <InvoiceCompleted
              open={invoiceCompleted}
              close={() => setInvoiceCompleted(false)}
              submit={invoiceCompletedHandler}
              message={"This invoice is already unblocked in SAP. Would you like to mark it as Completed?"}
            />
          )}
          {openWarningBox && (
            <WarningBox
              open={openWarningBox}
              close={() => setOpenWarningBox(false)}
              submit={warningFlag ? deleteAttachmentFunc : deleteInvoice}
              message="Are you sure to delete attachment"
              deleteLoader={deleteLoader}
              allow={1}
            />
          )}
        </Card>
      {/* ) : (
        <PageNotFound />
      )} */}
    </>
  );
};

export default APS_Invoice;
